import { Degree } from '@/models/Degree';
import { DegreeCommitIgnoredEvent } from './events/DegreeCommitIgnoredEvent';
import { DegreeCommittedEvent } from './events/DegreeCommittedEvent';
import { IGetters } from './interfaces/IGetters';
import { IMutations } from './interfaces/IMutations';
import { EventAggregationService } from '@/platform/EventAggregationService';

export class ActionCommitDegree {
	private readonly eventAggregationService: EventAggregationService;
	private readonly getters: IGetters;
	private readonly mutations: IMutations;

	public constructor(getters: IGetters, mutations: IMutations, eventAggregationService: EventAggregationService) {
		this.getters = getters;
		this.mutations = mutations;
		this.eventAggregationService = eventAggregationService;
	}

	public commit(degree: Degree | null, correlationId: number): void {
		const isCommitted = degree?.value === this.getters.getDegree().value;
		if (isCommitted) {
			this.publishCommitIgnored(correlationId);
			return;
		}

		degree = degree !== null && Degree.values.includes(degree.value) ? degree : this.getters.getDegree();
		this.mutations.setDegree(degree);
		this.publishCommitted(correlationId);
	}

	private publishCommitIgnored(correlationId: number): void {
		this.eventAggregationService.publish(new DegreeCommitIgnoredEvent(correlationId));
	}

	private publishCommitted(correlationId: number): void {
		this.eventAggregationService.publish(new DegreeCommittedEvent(correlationId));
	}
}
